function tabGroupFn() {
	const tabgroupbuttons = document.querySelectorAll('.tabgroup .tabgroup-tabs button.tabgroup-tab');
	tabgroupbuttons.forEach(function(button) {
		button.addEventListener('click', function() {
			const buttonwrapper = button.parentNode;
			const tabgroup = button.parentNode.parentNode;
			const newContentTab = button.getAttribute('data-tab');
			const relatedbuttons = buttonwrapper.querySelectorAll('button.tabgroup-tab');
			const contenttabs = tabgroup.querySelectorAll('.tab-content');

			if (!button.classList.contains('active')) {
				relatedbuttons.forEach(function(rbutton) {
					rbutton.classList.remove('active');
				});
				button.classList.add('active');

				contenttabs.forEach(function(contenttab) {
					contenttab.classList.remove('active');
				});
				tabgroup.querySelector('.tab-content.' + newContentTab).classList.add('active');
			}
		});
	});
}

const tabGroup = {
	init: function() {
		tabGroupFn();
	},
};

export default tabGroup;
